import { defineMessages } from 'react-intl';

export const currentPlanDisplayMessages = defineMessages({
  clinicianVisitPlanName: {
    defaultMessage: 'Clinician Standard',
    id: 'W2IxVqxuFp',
    description:
      'Display name for Clinician Pro on a standard seat when Heidi 2 opt-in is enabled',
  },
  clinicianMaxPlanName: {
    defaultMessage: 'Clinician Max',
    id: '0Vr3Psa5gG',
    description:
      'Display name for Clinician Pro on a Max seat when Heidi 2 opt-in is enabled',
  },
  practiceStandardPlanName: {
    defaultMessage: 'Practice Standard',
    id: 'sMn5xwWLQr',
    description: 'Display name for the Practice Standard plan in Heidi 2',
  },
  practiceMaxPlanName: {
    defaultMessage: 'Practice Max',
    id: 'URKV0C8zzC',
    description: 'Display name for the Practice Max plan in Heidi 2',
  },
  practiceMaxPlanDescription: {
    defaultMessage:
      'Team, Scribe, unlimited Evidence and maximum agentic usage for your whole clinic.',
    id: 'CSlknVNJ6M',
    description:
      'Current plan description in billing settings for a Practice Max seat in Heidi 2',
  },
});
